export default class {
  constructor() {
    this.$banner = document.getElementById('js-fixedBanner');
    this.lastScrollPosition = window.scrollY;
    this.$mainVisualArea = document.getElementById('js-bizEntryHeader');
    this.mainVisualScrollPosition = this.$mainVisualArea.offsetHeight;
  }

  init() {
    window.addEventListener('load', () => {
      this.mainVisualScrollPosition = this.$mainVisualArea.offsetHeight;
    });
    window.addEventListener('scroll', () => {
      const currentScrollPosition = window.scrollY;
      if (currentScrollPosition < this.lastScrollPosition && !this.$banner.classList.contains('is-viewed')) {
        this.$banner.classList.add('is-viewed');
      } else if (currentScrollPosition > this.lastScrollPosition && currentScrollPosition > this.mainVisualScrollPosition && this.$banner.classList.contains('is-viewed')) {
        this.$banner.classList.remove('is-viewed');
      }
      this.lastScrollPosition = currentScrollPosition;
    });
  }
}
